// extracted by mini-css-extract-plugin
module.exports = {"page":"page_page__28Do3","pageContent":"page_pageContent__Y8KRk","mainContent":"page_mainContent__2VqJi"};